import cx from 'classnames';
import { intcomma } from 'journalize';
import { Component, h } from 'preact';

import OtherCandidate from './OtherCandidate';
import { PreactHTMLConverter } from 'preact-html-converter';

// internal
import {
  sort_candidates_presidential,
  CandidateColorsRace1,
  CandidateColorsRace2,
  alert_conditionals,
  alert_winners,
  text_conditionals,
  text_conditional_winner_zero,
} from '../election-utils';
import sumValues from '../utils/sum-values';
import formatPercent from '../utils/format-percent';

import find from '../utils/find';

import { isCanvass, visibleCandidatesCount } from '../endpoints';

interface Props {
  partyName: string;
  tableHeader: JSX.Element;
  annotations: { [key: string]: any };
  notes: { [key: string]: any };
  isShowcaseRace?: boolean;
  isHomepage?: boolean;
  asOf: string;
  source: string;
  showDelegates: boolean;
  columnCount: number;
  ShowcaseRaceWinner: any;
  partyBallot: { [key: string]: any };
  renderCandidate: any;
  contestTitle: string;
  embedType: string;
}

class SeatPartyDivider extends Component {
  constructor() {
    super();

    this.state = {
      viewAllCandidates: false,
    };
    this.onViewableToggle = this.onViewableToggle.bind(this);
  }

  onViewableToggle() {
    this.setState(prevState => ({
      viewAllCandidates: !prevState.viewAllCandidates, // set viewAllCandidates to what is wasn't before
    }));
  }
  render() {
    const {
      partyName,
      annotations,
      notes,
      partyBallot,
      tableHeader,
      isShowcaseRace,
      isHomepage,
      columnCount,
      showDelegates,
      ShowcaseRaceWinner,
      asOf,
      source,
      renderCandidate,
      contestTitle,
      embedType,
    } = this.props;

    const { viewAllCandidates } = this.state;

    const converter = PreactHTMLConverter();

    const shouldDisplayResult = partyBallot.contest_result !== 'not called';

    // console.log(partyBallot.contest_result);

    const totalVotes = sumValues(partyBallot.candidacies, 'votes');

    let candidates = partyBallot.candidacies;

    const uncontested = candidates.length == 1;

    let ap_eevp = partyBallot.eevp;

    const pct_votes =
      source == 'Decision Desk HQ'
        ? formatPercent(totalVotes, partyBallot.estimated_votes_mid)
        : partyBallot.eevp;

    const pct_votes_turnout =
      pct_votes < 100
        ? `An estimated ${pct_votes}% of votes have been counted, according to the ${source}.`
        : `An estimated >99% of votes have been counted, according to the ${source}.`;

    const pct_votes_turnout_zero_winner =
      pct_votes == 0 && shouldDisplayResult ? `` : pct_votes_turnout;

    const pct_votes_turnout_w_uncontested =
      uncontested == true
        ? text_conditionals(pct_votes, partyBallot.candidacies.length)
        : pct_votes_turnout_zero_winner;

    const pct_votes_explain = !shouldDisplayResult
      ? text_conditionals(pct_votes, partyBallot.candidacies.length)
      : text_conditional_winner_zero(pct_votes, partyBallot.candidacies.length);

    let candidatesRender;

    let firstShowcaseRace;

    let embedTypeUsable = 'none';

    if (typeof embedType !== 'undefined') {
      embedTypeUsable = embedType;
    }

    let checkStyle;

    if (isShowcaseRace) {
      firstShowcaseRace =
        partyBallot.office == 'President' && partyBallot.party == 'Republican';
      // !isHomepage;

      candidatesRender = firstShowcaseRace
        ? CandidateColorsRace1
        : CandidateColorsRace2;

      if (ShowcaseRaceWinner) {
        const colorWinner = find(
          candidatesRender,
          candidate => candidate.name === ShowcaseRaceWinner['name']
        );

        if (colorWinner) {
          checkStyle = {
            color: colorWinner['color'],
          };
        }
      }
    }

    if (
      partyBallot.office == 'President' &&
      partyBallot.party == 'Republican' &&
      totalVotes == 0
    ) {
      candidates = sort_candidates_presidential(candidates);
    }

    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democrat',
      'seat__race--Republican': partyName == 'Republican',
    });

    const klaxon_sos = 'Race has been declared'; // if we switch sources to TX SOS and someone else has declared the winner

    const klaxon = shouldDisplayResult
      ? source == 'Decision Desk HQ' || source == 'Associated Press'
        ? alert_winners(partyBallot.contest_result, partyBallot.office)
        : klaxon_sos
      : alert_conditionals(pct_votes, partyBallot.candidacies.length);

    const checkmark = '\u2713';

    let checkClass = cx('check', {
      'dem-winner':
        partyBallot.party == 'Democrat' &&
        partyBallot.contest_result != 'runoff',
      'rep-winner':
        partyBallot.party == 'Republican' &&
        partyBallot.contest_result != 'runoff',
      'runoff-winner': partyBallot.contest_result == 'runoff',
    });

    const contestMetricsClass = cx('contest__metrics', {
      homepage__metrics: isHomepage,
      'non-homepage__metrics': !isHomepage,
    });

    let hasTurnoutmodel =
      source == 'Decision Desk HQ' || source == 'Associated Press'
        ? true
        : false;

    const precinctsClass = cx('contest__precincts');

    let ManualoverrideSource;

    // If there is a race, that's being manually updated, you can change the Source to whatever the new votes are coming from here if you uncomment the code below. This is only if the source isn't Texas Secretary of State. If it is, then you don't have to do anything.

    // if (partyBallot.office == 'U.S. House' && partyBallot.office_division == 37 && partyBallot.party == 'Republican') {
    //   ManualoverrideSource = 'Travis County Elections'
    // }
    // else {
    //   ManualoverrideSource = ''
    // }

    ManualoverrideSource = '';

    const IsAnnotations =
      annotations && annotations.length > 0 && annotations[0].value != ''
        ? true
        : false;

    const IsNoted = notes && notes.length > 0 ? true : false;

    return (
      <div class={rowClass}>
        <div class="race">
          {isHomepage ? (
            <span>
              <h2 class="office__title">{contestTitle}</h2>
              <h3 class="race__title">
                {partyName}
                {partyName == 'Democrat' && <span>ic</span>} Primary{' '}
              </h3>
            </span>
          ) : (
            <span>
              <h4 class="race__title">{partyName} </h4>
            </span>
          )}

          <div class={contestMetricsClass}>
            {isCanvass == false && (
              <h4 class="klaxon__text">
                {shouldDisplayResult &&
                (source == 'Decision Desk HQ' ||
                  source == 'Associated Press') ? (
                  <span class={checkClass} style={checkStyle}>
                    {checkmark}
                  </span>
                ) : (
                  ''
                )}
                {klaxon}
              </h4>
            )}
            {isCanvass == true &&
              shouldDisplayResult &&
              partyBallot.contest_result == 'runoff' && (
                <h4 class="klaxon__text klaxon__runoff">
                  Nominee to be decided in May runoff
                </h4>
              )}
            {ManualoverrideSource == '' && isCanvass == false && (
              <p class={precinctsClass}>
                {source == 'Texas Secretary of State'
                  ? `${intcomma(
                      partyBallot.pollinglocationsreporting
                    )} of ${intcomma(
                      partyBallot.total_pollinglocations
                    )} polling locations reporting (${partyBallot.pollinglocations_reporting_percent.toFixed(
                      1
                    )}%)`
                  : pct_votes_turnout_w_uncontested}{' '}
                {converter.convert(pct_votes_explain)}
              </p>
            )}
            {
              (ManualoverrideSource = !'' &&
                source != 'Texas Secretary of State' &&
                source != 'Decision Desk HQ' &&
                source != 'Associated Press' &&
                isCanvass == false && (
                  <p class={precinctsClass}>
                    {`${intcomma(
                      partyBallot.pollinglocationsreporting
                    )} of ${intcomma(
                      partyBallot.total_pollinglocations
                    )} polling locations reporting (${partyBallot.pollinglocations_reporting_percent.toFixed(
                      1
                    )}%)`}

                    {/* <span class="source">{` Source: ${ManualoverrideSource}`}</span> */}
                  </p>
                ))
            }
          </div>

          <table class="race__candidates">
            {tableHeader}
            <tbody>
              {isShowcaseRace &&
                candidates.map((candidate: any, idx: any) =>
                  renderCandidate(
                    candidate,
                    idx,
                    candidatesRender,
                    viewAllCandidates,
                    { totalVotes }
                  )
                )}

              {!isShowcaseRace &&
                candidates.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx, viewAllCandidates, {
                    totalVotes,
                  })
                )}
              {candidates.length > visibleCandidatesCount && (
                <OtherCandidate
                  isViewable={!viewAllCandidates}
                  candidateCount={candidates.length}
                  embedType={embedType}
                  onClick={() => {
                    this.onViewableToggle();
                  }}
                  showDelegates={showDelegates}
                />
              )}
            </tbody>

            {candidates.length > visibleCandidatesCount && viewAllCandidates && (
              <tr class="candidate race__candidate-row">
                <td
                  class="candidate__cell candidate__party t-align-center"
                  onClick={() => {
                    this.onViewableToggle();
                  }}
                >
                  <svg class="icon icon-angle-up">
                    <use xlinkHref="#icon-angle-up" />
                  </svg>
                </td>
                <th class="candidate__cell candidate__name">
                  <button
                    class={embedType}
                    onClick={() => {
                      this.onViewableToggle();
                    }}
                  >
                    Show fewer ({visibleCandidatesCount})
                  </button>
                </th>
                <th class="candidate__cell candidate__votes"> </th>
                <th class="candidate__cell candidate__pct"></th>
                {showDelegates && (
                  <td class="candidate__cell candidate__votes"></td>
                )}
              </tr>
            )}
          </table>

          {IsNoted == true && (
            <p class="note__text">{converter.convert(notes[0].value)}</p>
          )}
          {IsAnnotations == true && (
            <div class="anno-text notes-annotations">
              <span class="is-sr-only">Note:</span>
              <svg class="icon note-icon anno-div" aria-hidden="true">
                <use xlinkHref="#note-icon" />
              </svg>

              <p class="annotations t-links-underlined">
                <span class="font-weight-bold">Noteworthy: </span>
                {converter.convert(annotations[0].value)}
              </p>
            </div>
          )}
          <div class="below-races">
            <div class="source">{` Source: ${source}`}</div>

            {(isHomepage || embedType == 'internal') && (
              <div class="countdown">
                <span class="counter-homepage">LAST UPDATED {asOf}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SeatPartyDivider.defaultProps = {
  isShowcaseRace: false,
  isHomepage: false,
};

export default SeatPartyDivider;
